import React from 'react';

import { RecommendedActionsBlockData } from 'api/cms';
import Box from 'components/Box';
import { PrimaryButtonLink } from 'components/Button';
import { H2 } from 'components/Text';
import { colors, gutterWidth } from 'theme';
import { listingSearchHomePath } from 'utils/searchHomePages';

import { Card } from './CardsBlock';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Actions = () => (
  <amp-list
    width="auto"
    height="100"
    layout="fixed-height"
    src="/data/website/search/latest-actions"
    items="results"
    max-items="3"
  >
    <template type="amp-mustache">
      <Box
        // @ts-expect-error ts-migrate(2695) FIXME: Left side of comma operator is unused and has no s... Remove this comment to see the full error message
        display={('block', null, 'inline-block')}
        width={[1, null, 1 / 3]}
        verticalAlign="top"
        maxWidth={320}
        px={[0, null, gutterWidth / 2]}
        py={[gutterWidth / 2, null, 0]}
      >
        <Card
          card={{
            image: {
              filename: '{{logo.filename}}',
              handle: '{{logo.handle}}',
              mimetype: '{{logo.mimetype}}',
              size: parseInt('{{logo.size}}', 10),
              source: '{{logo.source}}',
            },
            headline: '{{name}}',
            text: '{{addressText}}',
            label: '{{orgName}}',
            urls: {
              en: '{{url.en}}',
              es: '{{url.es}}',
              pt: '{{url.pt}}',
            },
          }}
          imageSize="SMALL"
        />
      </Box>
    </template>
  </amp-list>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const RecommendedActionsBlock = ({
  data: { headline },
}: {
  data: RecommendedActionsBlockData;
}) => (
  <Box
    mx={[-gutterWidth / 2, null, -gutterWidth]}
    p={[gutterWidth / 2, null, gutterWidth]}
    borderRadius={[0, null, null, 48]}
    bg={colors.fog}
    textAlign="center"
  >
    {headline && <H2>{headline}</H2>}
    <PrimaryButtonLink href={`${listingSearchHomePath('JOB')}?q=`}>
      {getText('See All')}
    </PrimaryButtonLink>
    <Box mt={48}>
      <Actions />
    </Box>
  </Box>
);

export default RecommendedActionsBlock;
